import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';

// RP-4301: the range label while the total is not known yet ("1 – 100 of many").
@Injectable()
export class CountlessPaginatorIntl extends MatPaginatorIntl {
  // Evaluated on every render, so the label never lags the paginator state.
  unknownTotal: () => boolean = () => false;

  constructor() {
    super();
    const defaultRangeLabel = this.getRangeLabel;
    this.getRangeLabel = (page: number, pageSize: number, length: number): string => {
      if (!this.unknownTotal()) {
        return defaultRangeLabel(page, pageSize, length);
      }
      const start = page * pageSize + 1;
      return `${start} – ${start + pageSize - 1} of many`;
    };
  }
}
